import React from "react";
import { FaBook, FaPray, FaQuran } from "react-icons/fa";
import "./VerseCard.css";

const inspirations = [
  {
    id: 1,
    title: "Ayah Of The Day",
    content:
      "আর তারা আল্লাহ্‌কে ছেড়ে দিয়ে যাদের উপাসনা করে তাদের গালি দিও না, পাছে তারাও শত্রুতাবশতঃ আল্লাহ্‌কে গালি দেয় জ্ঞানহীনতার জন্য। এইভাবে প্রত্যেক সম্প্রদায়ের জন্য তাদের ক্রিয়াকলাপ আমরা চিত্তাকর্ষক করেছি। তারপর তাদের প্রভুর কাছেই হচ্ছে তাদের প্রত্যাবর্তন, তখন তিনি তাদের জানিয়ে দেবেন কি তারা করতো।",
    ref: "Al Aa'nam, 108",
    icon: <FaQuran />,
    gradient: "gradient-green",
  },
  {
    id: 2,
    title: "Hadith Of The Day",
    content:
      "হাসান ইবন ‘আলী (রহঃ) ..... আবূ হুরায়রা (রাঃ) সূত্রে নবী সাল্লাল্লাহু আলাইহি ওয়াসাল্লাম থেকে বর্ণিত। তিনি বলেনঃ যে ব্যক্তি পশুদের রক্ষণাবেক্ষণ, শিকারের উদ্দেশ্যে বা ক্ষেত-খামারের সংরক্ষণের প্রয়োজন ছাড়া কুকুর প্রতিপালন করে তার সওয়াব হতে প্রত্যহ এক ‘কিরাত’ কম হবে।",
    ref: "সূনান আবু দাউদ, ২৮৩৫",
    icon: <FaBook />,
    gradient: "gradient-blue",
  },
  {
    id: 3,
    title: "Dua Of The Day",
    content:
      "Alhamdulillah hil’ladhi ah’yaana ba’damaa amaa’tanaa wa ilay’hin nushoor.",
    ref: "Sahih Muslim 4/2083",
    icon: <FaPray />,
    gradient: "gradient-purple",
  },
];

const VerseCard = () => {
  return (
    <section className="daily-inspirations">
      <h2 className="section-title">Daily Inspirations</h2>

      <div className="cards-container">
        {inspirations.map((item) => (
          <div key={item.id} className={`cardParent ${item.gradient}`}>
            <div className="card-icon">{item.icon}</div>

            <h3 className="card-title">{item.title}</h3>

            <p className="card-content">{item.content}</p>

            <span className="card-ref">{item.ref}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default VerseCard;
